import { type PHEmploymentMenuItem } from "../Employment.types";

export const employmentMenuItemsFinmerkadoPH: PHEmploymentMenuItem[] = [
  { label: "inputs.employment.employed", value: "EMPLOYED" },
  { label: "inputs.employment.self_employed", value: "SELF_EMPLOYED" },
  { label: "inputs.employment.business_owner", value: "BUSINESS_OWNER" },
  { label: "inputs.employment.freelancer", value: "FREELANCER" },
  { label: "inputs.employment.not_employed", value: "UNEMPLOYED" },
  { label: "inputs.employment.private_sector", value: "PRIVATE_SECTOR" },
  { label: "inputs.employment.public_sector", value: "PUBLIC_SECTOR" },
  {
    label: "inputs.employment.business_process_outsourcing",
    value: "BUSINESS_PROCESS_OUTSOURCING",
  },
  { label: "inputs.employment.overseas_worker", value: "OVERSEAS_WORKER" },
  { label: "inputs.employment.foreign_resident", value: "FOREIGN_RESIDENT" },
  { label: "inputs.employment.other", value: "OTHER" },
];
